// Lógica pura de "pan por arrastre" + "pista de descubrimiento (glow)" del visor
// de evidencias (POD) en ServiceValidationPods. Se extrae aquí para poder
// probarla sin renderizar el componente (mismo patrón que filterDefaults.js),
// ya que el runner de tests CRA no es fiable sobre Vite.

// Estado inicial del arrastre (se guarda en un ref dentro del componente, no en
// estado React: mutarlo no debe provocar re-render).
export const initialDragState = () => ({
  dragging: false,
  startX: 0,
  startY: 0,
  scrollLeft: 0,
  scrollTop: 0,
})

// Al pulsar el ratón: captura la posición inicial del cursor y el scroll actual
// del contenedor, y marca el arrastre como activo.
export const beginDrag = (el, e) => ({
  dragging: true,
  startX: e.clientX,
  startY: e.clientY,
  scrollLeft: el.scrollLeft,
  scrollTop: el.scrollTop,
})

// Posición de scroll resultante al mover el ratón mientras se arrastra. Devuelve
// el nuevo { scrollLeft, scrollTop } del contenedor (scroll inverso al drag:
// arrastrar a la derecha desplaza el contenido a la derecha => menor scrollLeft).
export const panScrollPosition = (drag, e) => ({
  scrollLeft: drag.scrollLeft - (e.clientX - drag.startX),
  scrollTop: drag.scrollTop - (e.clientY - drag.startY),
})

// Transición de la pista de descubrimiento: una vez vista, permanece vista
// (idempotente). Evita re-renders innecesarios devolviendo el mismo valor.
export const markHintSeen = (seen) => (seen ? seen : true)
